<template>
  <div v-if="show" class="age-confirm-modal">
    <div class="age-confirm-modal-background">

    </div>
    <div class="age-confirm-modal-body">
      <div class="age-confirm-modal-body-content">
        <div class="age-confirm-modal-body-content-headline">
          We'll be back soon!
        </div>
        <div class="age-confirm-modal-body-content-text">
          <p>Our website is currently undergoing scheduled maintenance. We’re working hard to improve your experience.</p>
          <p>Thank you for your patience!</p>
        </div>
      </div>
      <div class="age-confirm-modal-body-footer">
        <button @click="refreshPage" class="btn btn-primary btn-rounded button-create-account">Refresh page</button>
        <button @click="logOut" class="btn btn-rounded btn-default button-login">Logout</button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions, mapState} from 'vuex'

export default {
  props: [],
  mixins: [
    require('@general/lib/mixin').default
  ],
  computed: {
    ...mapGetters({
    }),
    ...mapState({
      show: state => state.modal.maintenance_mode,
    })
  },
  methods: {
    ...mapActions([
    ]),
    showPagePopup(page) {
      //app.showLightLoading(true);

      let title = page == 'terms' ? this.trans('reg.terms_of_use') : this.trans('reg.privacy_policy');

      axios.get('/api/getStaticPage/'+app.lang+'/'+page)
          .then(({data}) => {
            this.showErrorNotification(data.content);
            //app.showLightLoading(false);
          })
          .catch(e => {
            //app.showLightLoading(false);
          })
    },
    logOut : function (){
     this.logout();
    },
    refreshPage: function(){
      location.reload();
    }
  },
  data() {
    return {
    }
  }
}
</script>
